import type {AiChatGeneratedAssetFilter} from '@AiChat/ai-chat.types';

export const EMPTY_STATE_IMAGE_ILLUSTRATION_PATH = 'poster-editor-thumbnails/ai-text-to-image-empty-visual.png';

export interface AiChatAssetsEmptyStateProps {
  filter: AiChatGeneratedAssetFilter;
}
